import { extendTheme } from "@chakra-ui/react";

export const createChakraTheme = (customTheme: any) =>
  extendTheme({
    styles: {
      global: {
        body: {
          bg: customTheme.background,
          color: customTheme.text,
        },
      },
    },

    colors: {
      brand: {
        500: customTheme.primary,
      },
      success: {
        500: customTheme.success,
      },
      warning: {
        500: customTheme.warning,
      },
      danger: {
        500: customTheme.danger,
      },
    },

    components: {
      Button: {
        defaultProps: {
          colorScheme: "brand",
        },
      },
      Input: {
        defaultProps: {
          focusBorderColor: "brand.500",
        },
      },
      Select: {
        defaultProps: {
          focusBorderColor: "brand.500",
        },
      },
      Switch: {
        defaultProps: {
          colorScheme: "brand",
        },
      },
    },
  });
